export function processNodeId(process) {
  return String(process?.id ?? '').trim();
}

export function defaultProcessPosition(index) {
  const cols = 3;
  const col = index % cols;
  const row = Math.floor(index / cols);
  return {
    x: 72 + col * 400,
    y: 64 + row * 250,
  };
}
